var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1434_42051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 83C64.9198 83 83.5 64.4198 83.5 41.5C83.5 18.5802 64.9198 0 42 0C19.0802 0 0.5 18.5802 0.5 41.5C0.5 64.4198 19.0802 83 42 83Z",
    fill: "url(#paint0_linear_1434_42051)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1434_42051)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.2793,
    y: 13.0684,
    width: 43.9854,
    height: 54.7549,
    rx: 5.65106,
    fill: "url(#paint1_linear_1434_42051)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 24.166,
    y: 20.1318,
    width: 17.6596,
    height: 3.46128,
    rx: 1.73064,
    fill: "#4F6FFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.166,
    y: 29.9512,
    width: 35.3191,
    height: 3.46128,
    rx: 1.73064,
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.166,
    y: 39.7695,
    width: 35.3191,
    height: 3.46128,
    rx: 1.73064,
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.166,
    y: 49.5879,
    width: 35.3191,
    height: 3.46128,
    rx: 1.73064,
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.166,
    y: 59.4072,
    width: 35.3191,
    height: 3.46128,
    rx: 1.73064,
    fill: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1434_42051)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.3051,
    cy: 57.5697,
    r: 14.4809,
    fill: "#4F6FFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2402 58.7635L54.8532 62.1937C55.2969 62.5236 55.9241 62.4309 56.2533 61.9867L62.7603 53.208",
    stroke: "#4F6FFD",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2402 58.7635L54.8532 62.1937C55.2969 62.5236 55.9241 62.4309 56.2533 61.9867L62.7603 53.208",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1434_42051",
    x: 9.68355,
    y: 9.53644,
    width: 65.1778,
    height: 75.9464,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.06383
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.29787
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1434_42051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1434_42051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1434_42051",
    x: 40.4115,
    y: 43.0889,
    width: 31.7865,
    height: 31.7874,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.41277
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.706383
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1434_42051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1434_42051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1434_42051",
    x1: 30.6979,
    y1: 3.02039e-7,
    x2: 42.5302,
    y2: 132.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8C5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1434_42051",
    x1: 42.272,
    y1: 13.0684,
    x2: 42.272,
    y2: 67.8232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1434_42051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 83,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteIcon);
export default __webpack_public_path__ + "static/media/complete-icon.a15cec86043b4bdde5c5adba38fc8865.svg";
export { ForwardRef as ReactComponent };